import Image from "next/future/image";
import styles from "./style.module.scss";

const Heading = ({ title, subTitle, image, description, styleTopTitle }) => {
  return (
    <div className={`${styles["head-title"]} head-title flex-center`}>
      <div className="why flex-center">
        <span>{subTitle}</span>
      </div>
      <div className="content-div">
        <h2 className={`${styleTopTitle ? "top" : ""} main-title-section`}>
          {title}
        </h2>
        {description && (
          <div
            className="bottom main-title-section"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </div>
      {image && (
        <div className="rocket-div">
          <Image
            src={image}
            alt="rocket"
            width={300}
            height={300}
            priority={false}
            loading="lazy"
          />
        </div>
      )}
    </div>
  );
};

export default Heading;
